<template>
  <div class="w-full">
    <slot />
	</div>
</template>

<script setup lang="ts">
import {ARTICLE_QUERY_TYPE, useArticlesStore} from "~/stores/useArticlesStore"
import {ArticleStoreType} from "~/libs/constants/ArticleStoreType"
import type ArticleFilters from "~/libs/interfaces/ArticleFilters"
import {DEBUG_COOKIE} from "~/libs/constants/constants"

const debugCookie = useCookie(DEBUG_COOKIE)
const logger = useFrontendLogger()
const config = useRuntimeConfig()
const articleCurrentEditionStore = useArticlesStore(ArticleStoreType.CURRENT_EDITION)


/**
 * Load current edition if possible
 */
onMounted(async () => {
  const getArticleId = () => {
    if (!config.public.currentEditionArticleId) {
      return
    }
    return useApiIdConverter().apiIdToUuid(config.public.currentEditionArticleId) as string
  }

  const filters: ArticleFilters = {
    ...(getArticleId() && {
      ids: [getArticleId() as string]
    })
  }

  try {
    if (getArticleId()) {
      articleCurrentEditionStore.setLimit(1)
      articleCurrentEditionStore.fetchArticles(filters, ARTICLE_QUERY_TYPE.PREVIEW, {
        forceRefetch: false,
        useDefaultFilters: false,
        usePublishedStateFilters: false,
      })

      if (debugCookie) {
        logger?.info('Loaded current edition', articleCurrentEditionStore.article)
      }
    }
  } catch (e) {
    logger?.error('Can not load current edition article', {
      filters,
      errorDetail: e,
    })
  }
})
</script>
